import {
    Tabs as ReactTabs, Tab, TabList, TabPanel,
} from 'react-tabs';
import { v4 as uuidV4 } from 'uuid';
import { useMemo } from 'react';
import { ITabsLayout } from '../../types/layout/tabs';
import LayoutFactory from '../../factories/layout-factory';
import Card from '../card';
import TabTitle from './title';
import LayoutContextWrapper from '../../contexts/layout';

function Tabs({
    breakpointColumn, collapsable, collapsed, className, elements, title, rowId,
}: ITabsLayout & { rowId?: string | number; }) {
    const layoutId = useMemo(() => uuidV4(), []);

    return (
        <Card
            breakpointColumn={breakpointColumn}
            collapsable={collapsable}
            collapsed={collapsed}
            className={className}
            elements={[]}
            title={title}
            type="card"
        >
            <ReactTabs selectedTabClassName="tabs-select-list-item">
                <TabList>
                    {elements.map((item) => (
                        <Tab key={item.title}>
                            <TabTitle {...item} />
                        </Tab>
                    ))}
                </TabList>
                {elements.map((item) => (
                    <TabPanel key={item.title}>
                        <LayoutContextWrapper layoutId={layoutId}>
                            <LayoutFactory layout={item.elements} rowId={rowId} />
                        </LayoutContextWrapper>
                    </TabPanel>
                ))}
            </ReactTabs>
        </Card>
    );
}

Tabs.defaultProps = {
    rowId: undefined,
};

export default Tabs;
